<template>
    <div v-if="data">
        <template v-for="dateGroup in data.Dates ?? []" :key="dateGroup.Date">
            <h3>{{ dateGroup.Date }}</h3>

            <div class="flex gap-8 mb-8">
                <div v-for="category in dateGroup.Categories" :key="category.GroupName" class="grow">
                    <h4>{{ category.GroupName }}</h4>

                    <ul>
                        <li
                            v-for="item in category.Items"
                            :key="`${item.ChangeDate}-${item.CompanyName}-${item.Change}`">
                            <span class="font-bold mr-1">{{ item.CompanyName }}</span>
                            <span>{{ item.Change }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </template>
    </div>
</template>
<script setup lang="ts">
type CompanyChangeLogItem = {
    ChangeDate: string;
    ChangeDateTime: string;
    CompanyName: string;
    Change: string;
    TableName: string;
};

type CompanyChangeLogCategory = {
    GroupName: string;
    Items: CompanyChangeLogItem[];
};

type CompanyChangeLogDateGroup = {
    Date: string;
    Categories: CompanyChangeLogCategory[];
};

type CompanyChangeLogResponse = {
    Dates: CompanyChangeLogDateGroup[];
};

const { data } = await useApi<CompanyChangeLogResponse>("company-change-log");
</script>
